/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QueueMessageStatusEnum } from './queueMessageStatusEnum';


export interface InventoryQueueMessage { 
    /**
     * Message id
     */
    message_id: string;
    status: QueueMessageStatusEnum;
    /**
     * Provider identifier(can be providerId, entityId or componentId)
     */
    topic_name: string;
    payload: string;
    queued_timestamp: Date;
    dequeued_timestamp: Date;
}
export namespace InventoryQueueMessage {
}


